import { NgModule } from "@angular/core";
import { CommonModule, DecimalPipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TableComponent } from "./component/table/table.component";
import { AlertComponent } from "./component/alert/alert.component";
import { NoDecimalPipe } from "./pipe/no-decimal.pipe";
import { FilterPipe } from "./pipe/filter.pipe";
import { TablePipe } from './pipe/table.pipe';
import { ItemFilterPipe } from './pipe/itemFilter.pipe';
import { GroupByPipe } from './pipe/groupBy.Pipe ';
import { OrderByPipe } from './pipe/orderBy.Pipe';
import { FilterPropertyPipe } from './pipe/filterByProperty';
import { ItemSearchComponent } from "./component/item-search/item-search.component";
import { GridEditComponent } from "./component/grid-edit/grid-edit.component";
import { ReportViewerComponent } from "./component/report-viewer/report-viewer.component";
import { VchrprintComponent } from "./component/vchrprint/vchrprint.component";
import { ImportfromfileComponent } from './component/importfromfile/importfromfile.component'
import { BootstrapModalModule } from "./component/dialog/bootstrap-modal.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { RptFiterComponent } from './component/rpt-fiter/rpt-fiter.component';
import { InReportService } from '../shared/services/inventory/in-report.service';
import { ProductSearchComponent } from './component/product-search/product-search.component';
import { TablePopupComponent } from './component/table-popup/table-popup.component';
import { TableModule } from 'primeng/table';
import { BarcodePrintComponent } from './component/barcode-print/barcode-print.component';
import { RestItemSearchComponent } from "./component/rest-item-search/rest-item-search.component";
import { RestComboItemsearchComponent } from "./component/rest-combo-itemsearch/rest-combo-itemsearch.component";
import { RestRecipeitemSearchComponent } from "./component/rest-recipeitem-search/rest-recipeitem-search.component";
import { SupplierSearchComponent } from './component/supplier-search/supplier-search.component';
import { ChequeprintComponent } from './component/chequeprint/chequeprint.component';
import { ChqprintComponent } from './component/chqprint/chqprint.component';
import { UserroleSearchComponent } from './component/userrole-search/userrole-search.component';
import { RoleSearchComponent } from './component/role-search/role-search.component';
import { PrivilegeSearchComponent } from './component/privilege-search/privilege-search.component';
import { TransactionhistoryComponent } from './component/transactionhistory/transactionhistory.component';
import { MobilepdtSearchComponent } from './component/mobilepdt-search/mobilepdt-search.component';
import { PurchasehistoryComponent } from './component/purchasehistory/purchasehistory.component';
import { ItemMasterComponent } from './component/item-master/item-master.component';
import { ProductComponent } from "../lazy-modules/+private-page/inventory/products/product-grp/product/product.component";
import { PromotionaddbulkComponent } from './component/promotionaddbulk/promotionaddbulk.component';
import { DeleteitemComponent } from './component/deleteitem/deleteitem.component';
import { SalescontactComponent } from './component/salescontact/salescontact.component';
import { ContactSearchComponent } from './component/contact-search/contact-search.component';
import { RestcustomerSearchComponent } from './component/restcustomer-search/restcustomer-search.component';
import { SalescontacthistoryComponent } from './component/salescontacthistory/salescontacthistory.component';
import { NoDecimalRecipiePipe } from "./pipe/nodecimalrecipie.pipe";
import { SalesorderSearchComponent } from './component/salesorder-search/salesorder-search.component';
import { DeliverynoteSearchComponent } from './component/deliverynote-search/deliverynote-search.component';
import { DnserachBosaleComponent } from './component/dnserach-bosale/dnserach-bosale.component';
import { ImageUploaderComponent } from './component/image-uploader/image-uploader.component';
import { MaterialrequisitionSearchComponent } from './component/materialrequisition-search/materialrequisition-search.component';
import { UnpostsalesComponent } from './component/unpostsales/unpostsales.component';
import { ExpiryEditComponent } from './component/expiry-edit/expiry-edit.component';
import { CurrencyPopUpComponent } from './component/currency-popup/currency-popup.component';
import { ExpiryDetailsStockComponent } from './component/expirydetails-stock/expirydetails-stock.component';
import { SellingPriceLevelPopUpComponent } from './component/sellingpricelevel-popup/sellingpricelevel-popup.component';
import { ReverseChargeEditComponent } from './component/reversecharge-edit/reversecharge-edit.component';
import { SellingPriceEditComponent } from './component/sellingprice-edit/sellingprice-edit.component';
import { PriceChangeComponent } from './component/pricechange/pricechange.component';
import { UnpostPdcPopUpComponent } from './component/unpostpdc-popup/unpostpdc-popup.component';
import { AddChargePopUpComponent } from './component/addcharge-popup/addcharge-popup.component';
import { CashCollectionEditComponent } from './component/cashcollection-edit/cashcollection-edit.component';
import { SalesHistoryPopupComponent } from './component/saleshistory-popup/saleshistory-popup.component';
import { AddItemComponent } from './component/add-item/add-item.component';
import { ImageSelectComponent } from './component/imageselect/imageselect.component';
import { PromotionItemImageComponent } from './component/promotionitemimage/promotionitemimage.component';
import { ImportComponent } from './component/import/import.component'
import { PromotionDiscountAddBulkComponent } from './component/promotiondiscountaddbulk/promotiondiscountaddbulk.component';
import { ZatcaTransactionComponent } from './component/zatcatransaction/zatcatransaction.component';
import { StockListPopupComponent } from './component/stocklist-popup/stocklist-popup.component';
import { ImportItemComponent } from './component/importitem/importitem.component';
import { GrnSearchComponent } from './component/grn-search/grn-search.component';
import { SerialNumberTrackComponent } from './component/serialnumbertrack/serialnumbertrack.component';
import { VideoUploaderComponent } from './component/video-uploader/video-uploader.component';
import { PrimengModule } from '../shared/modules/primeng/primeng.module';
import { SellingPriceLevelMappingPopUpComponent } from './component/sellingpricelevelmapping-popup/sellingpricelevelmapping-popup.component';
import { PriceSearchComponent } from './component/price-search/price-search.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    BootstrapModalModule.forRoot({ container: document.body }),
    TableModule,
    PrimengModule
  ],
  exports: [
    FormsModule, TableComponent, AlertComponent, NgSelectModule, BootstrapModalModule,
    NoDecimalPipe, FilterPipe, FilterPropertyPipe, ReportViewerComponent, TablePipe, ItemFilterPipe, GroupByPipe,
    RestItemSearchComponent, RestComboItemsearchComponent, RestRecipeitemSearchComponent,
    ChequeprintComponent, ChqprintComponent, MobilepdtSearchComponent, PurchasehistoryComponent, ItemMasterComponent,
    ProductComponent, BarcodePrintComponent, PromotionaddbulkComponent, DeleteitemComponent,
    SalescontactComponent, ContactSearchComponent, RestcustomerSearchComponent, SalescontacthistoryComponent,
    NoDecimalRecipiePipe, SalesorderSearchComponent, DeliverynoteSearchComponent, DnserachBosaleComponent,
    ImageUploaderComponent, MaterialrequisitionSearchComponent, UnpostsalesComponent, ExpiryEditComponent, CurrencyPopUpComponent,
    ExpiryDetailsStockComponent, OrderByPipe, SellingPriceLevelPopUpComponent, ReverseChargeEditComponent, SellingPriceEditComponent, PriceChangeComponent,
    UnpostPdcPopUpComponent, AddChargePopUpComponent, CashCollectionEditComponent, SalesHistoryPopupComponent, AddItemComponent, ImageSelectComponent,
    PromotionItemImageComponent, ImportComponent, PromotionDiscountAddBulkComponent, ZatcaTransactionComponent, StockListPopupComponent, ImportItemComponent,
    GrnSearchComponent, SerialNumberTrackComponent, VideoUploaderComponent, SellingPriceLevelMappingPopUpComponent, PriceSearchComponent
  ],
  declarations: [
    TableComponent,
    AlertComponent,
    ItemSearchComponent,
    GridEditComponent,
    ReportViewerComponent,
    VchrprintComponent,
    NoDecimalPipe,
    FilterPipe,
    FilterPropertyPipe,
    TablePipe,
    RptFiterComponent,
    ImportfromfileComponent,
    ProductSearchComponent,
    ItemFilterPipe,
    TablePopupComponent,
    GroupByPipe,
    BarcodePrintComponent,
    RestItemSearchComponent,
    RestComboItemsearchComponent,
    RestRecipeitemSearchComponent,
    SupplierSearchComponent,
    ChequeprintComponent,
    ChqprintComponent,
    UserroleSearchComponent,
    RoleSearchComponent,
    PrivilegeSearchComponent,
    TransactionhistoryComponent,
    MobilepdtSearchComponent,
    PurchasehistoryComponent,
    ItemMasterComponent,
    ProductComponent,
    PromotionaddbulkComponent,
    DeleteitemComponent,
    SalescontactComponent,
    ContactSearchComponent,
    RestcustomerSearchComponent,
    SalescontacthistoryComponent,
    NoDecimalRecipiePipe,
    SalesorderSearchComponent,
    DeliverynoteSearchComponent,
    DnserachBosaleComponent,
    ImageUploaderComponent,
    MaterialrequisitionSearchComponent,
    UnpostsalesComponent,
    ExpiryEditComponent,
    CurrencyPopUpComponent,
    ExpiryDetailsStockComponent,
    OrderByPipe,
    SellingPriceLevelPopUpComponent,
    ReverseChargeEditComponent,
    SellingPriceEditComponent,
    PriceChangeComponent,
    UnpostPdcPopUpComponent,
    AddChargePopUpComponent,
    CashCollectionEditComponent,
    SalesHistoryPopupComponent,
    AddItemComponent,
    ImageSelectComponent,
    PromotionItemImageComponent,
    ImportComponent,
    PromotionDiscountAddBulkComponent,
    ZatcaTransactionComponent,
    StockListPopupComponent,
    ImportItemComponent,
    GrnSearchComponent,
    SerialNumberTrackComponent,
    VideoUploaderComponent,
    SellingPriceLevelMappingPopUpComponent,
    PriceSearchComponent
  ],
  entryComponents: [ItemSearchComponent, GridEditComponent, VchrprintComponent, RptFiterComponent, ImportfromfileComponent,
    ProductSearchComponent, TablePopupComponent, BarcodePrintComponent, RestItemSearchComponent, RestComboItemsearchComponent,
    RestRecipeitemSearchComponent, SupplierSearchComponent, ChequeprintComponent, ChqprintComponent, UserroleSearchComponent,
    PrivilegeSearchComponent, TransactionhistoryComponent, MobilepdtSearchComponent, PurchasehistoryComponent, ItemMasterComponent,
    ProductComponent, PromotionaddbulkComponent, DeleteitemComponent, SalescontactComponent, ContactSearchComponent, RestcustomerSearchComponent, SalescontacthistoryComponent,
    SalesorderSearchComponent, DeliverynoteSearchComponent, DnserachBosaleComponent, MaterialrequisitionSearchComponent, UnpostsalesComponent,
    ExpiryEditComponent, CurrencyPopUpComponent, ExpiryDetailsStockComponent, SellingPriceLevelPopUpComponent, ReverseChargeEditComponent, SellingPriceEditComponent, PriceChangeComponent,
    UnpostPdcPopUpComponent, AddChargePopUpComponent, CashCollectionEditComponent, SalesHistoryPopupComponent, AddItemComponent, ImageSelectComponent, PromotionItemImageComponent,
    ImportComponent, PromotionDiscountAddBulkComponent, ZatcaTransactionComponent, StockListPopupComponent, ImportItemComponent, GrnSearchComponent, SerialNumberTrackComponent,
    SellingPriceLevelMappingPopUpComponent, PriceSearchComponent
  ],
  providers: [DecimalPipe]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/shared.module.ts